import React from 'react'
import { DialogTitle, DialogTitleProps } from '@material-ui/core'

export default function AlertDialogTitle(props: DialogTitleProps) {
  return <DialogTitle {...props} disableTypography />
}
